var defaultFont = "\"Verdana\", Arial, sans-serif";
export var DataGridStylingDefaults = {};
//# sourceMappingURL=DataGridStylingDefaults.js.map
